
























































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { range } from 'lodash'
import moment from 'moment'

interface MeetingDay {
    date: Date | string
    dayNumber: string
    dayLabel: string
    current: boolean
    selected: boolean
    [key: string]: any
}

interface MeetingDayPart {
    moments: MeetingMoment[]
    [key: string]: any
}

interface MeetingMoment {
    date: Date | string
    label: string
    selected: boolean
    [key: string]: any
}

@Component
export default class InputDateTime extends Vue {
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly value!: Date
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    internalValue: Date = null

    startDate: Date = null
    meetingDays: MeetingDay[] = []
    meetingHours: MeetingDayPart[] = []
    selectedMeetingDay: MeetingDay = null
    selectedMeetingMoment: MeetingMoment = null

    created() {

        /** Implemented because if a sunday would be selected the next week would be shown */
        const dayIndexWeekStart = moment(this.value).day() === 0 ? -6 : 1

        this.startDate = (this.value ? moment(this.value) : moment()).day(dayIndexWeekStart).toDate()
        this.meetingDays = this.generateWeek()
        this.meetingHours = this.generateDay(moment().toDate())
        this.onExternalChange()
    }

    mounted() {
        setTimeout(() => {
            const elems = document.querySelectorAll('.hour.selected')
            const elem = elems.length > 0 ? elems.item(0) : null

            if (elem) {
                elem.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
        }, 200)
    }

    prevDate(): void {
        this.startDate = moment(this.startDate).subtract(1, 'week').toDate()
        this.meetingDays = this.generateWeek()
    }

    nextDate(): void {
        this.startDate = moment(this.startDate).add(1, 'week').toDate()
        this.meetingDays = this.generateWeek()
    }

    setMeetingMoment(meetingMoment: MeetingMoment): void {
      if (this.selectedMeetingMoment) {
        this.selectedMeetingMoment.selected = false
      }

      meetingMoment.selected = true
      this.selectedMeetingMoment = meetingMoment
    }

    setMeetingDay(meetingDay: MeetingDay): void {
      if (this.selectedMeetingDay) {
          this.selectedMeetingDay.selected = false
      }

      meetingDay.selected = true
      this.selectedMeetingDay = meetingDay
    }

    generateWeek(): MeetingDay[] {
        const meetingDays = []

        for (let day = 0; day <= 6; day++) {
            const currentDay = moment(this.startDate).add(day, 'days')

            const meetingDay = {
              dayNumber: currentDay.format('D'),
              dayLabel: currentDay.format('dd'),
              current: moment().isSame(currentDay, 'day'),
              selected: this.value ? currentDay.isSame(this.value, 'day') : false,
              date: currentDay.toDate(),
            }

            if (meetingDay.selected) {
                this.selectedMeetingDay = meetingDay
            }

            meetingDays.push(meetingDay)
        }

        return meetingDays
    }

    generateDay(date: Date): MeetingDayPart[] {

        const morning = range(7, 12)
        const afternoon = range(12, 18)
        const evening = range(18, 21)
        const day = [morning, afternoon, evening]
        const minutes = range(0, 60, 15)
        const valueDate = moment(this.value)

        return [
            ...day.map(dayPart => ({
                moments: dayPart.map(hour => (
                    minutes.map(minute => {

                        const momentDate = moment(date).hour(hour).minute(minute).seconds(0).millisecond(0)

                        const meetingMoment = {
                          date: momentDate.toDate(),
                          label: momentDate.format('HH:mm'),
                          selected: valueDate.isSame(moment(this.value).hour(hour).minute(minute), 'minute'),
                        }

                        if (meetingMoment.selected) {
                            this.selectedMeetingMoment = meetingMoment
                        }

                        return meetingMoment
                    })
              )).flat(),
            })),
        ]
    }

    dayActiveClass(meetingDay: MeetingDay): null|string {
        if (!meetingDay.selected && !meetingDay.current) {
          return null
        }

        return meetingDay.selected ? 'selected' : 'current'
    }

    momentActiveClass(meetingDay: MeetingMoment): string {
        return meetingDay.selected ? 'hour selected' : 'hour'
    }

    @Watch('selectedMeetingDay')
    onDayChange(): void {
        this.calculateValue()
    }

    @Watch('selectedMeetingMoment')
    onMomentChange(): void {
        this.calculateValue()
    }

    calculateValue(): void {
        if (!this.selectedMeetingDay || !this.selectedMeetingMoment) {
            return
        }

        const date = moment(this.selectedMeetingDay.date)
        const meetingDate = moment(this.selectedMeetingMoment.date)

        date.hour(meetingDate.hour())
        date.minute(meetingDate.minute())

        this.internalValue = date.seconds(0).millisecond(0).toDate()
    }

    @Watch('internalValue')
    onInternalChange(): void {
        if (moment(this.internalValue).isSame(moment(this.value)) === false) {
            this.$emit('input', moment(this.internalValue).toISOString(true))
        }
    }

    @Watch('value')
    onExternalChange(): void {
        this.internalValue = moment(this.value).toDate()
    }

    onInput(): void {
        this.$emit('input', moment(this.internalValue).toISOString(true))
    }

    get componentClass(): object {
        return {
            'input-date-time': true,
            'input-date-time--disabled': this.disabled,
        }
    }

    get weekLabel(): null|string {

        if (moment().isSame(this.startDate, 'week')) {
            return
        }

        const firstDayOfWeek = moment(this.startDate)
        const lastDayOfWeek = moment(this.startDate).add(6, 'days')

        if (firstDayOfWeek.isSame(lastDayOfWeek, 'month')) {

            const firstDayFormat = this.$i18n.locale === 'nl' ? 'D' : 'MMMM Do'
            const lastDayFormat = this.$i18n.locale === 'nl' ? 'D MMMM' : 'Do'

            return `${firstDayOfWeek.format(firstDayFormat)} - ${lastDayOfWeek.format(lastDayFormat)}`
        }

        const format = this.$i18n.locale === 'nl' ? 'D MMMM' : 'MMMM Do'

        return `${firstDayOfWeek.format(format)} - ${lastDayOfWeek.format(format)}`
    }

}
